import { api } from '@/api/axiosInstance';
import { ApiResponseType } from '@/api/type/commonTypes';
import { PostAddLicenseKeyMemoResponse } from '../type/types';

interface postAddLicenseKeyMemoProps {
  licenseKeyId: string;
  memo: string;
}

/** 라이선스 키 메모 등록 */
export const postAddLicenseKeyMemo = async (
  data: postAddLicenseKeyMemoProps
) => {
  const res = await api.post<ApiResponseType<PostAddLicenseKeyMemoResponse>>(
    `/api/web/admins/license-keys/${data.licenseKeyId}/memo`,
    data
  );
  return res.data;
};
